module.exports = __webpack_public_path__ + "static/media/building-construction-icon.8706e1e9.svg";